import { useUnit } from 'effector-react'

import { $users, usersListMounted, getUsers, $totalCountOfUsers } from './model'
import { UserGroupsRequest } from '../../groups/list/types'

export const useUsersList = () => {
  const loading = useUnit(getUsers.pending)

  const users = useUnit($users)
  const totalCountOfUsers = useUnit($totalCountOfUsers)

  const onChangeUsersList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
  }: UserGroupsRequest) => {
    usersListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
    })
  }

  return { users, loading, onChangeUsersList, totalCountOfUsers }
}
